import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-281a566d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-item--1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-text--1" }, "商家名称", -1))
const _hoisted_3 = { class: "notice-text--2" }
const _hoisted_4 = { class: "notice-item--2" }
const _hoisted_5 = { class: "notice-text--1" }
const _hoisted_6 = { class: "notice-text--2" }
const _hoisted_7 = { class: "notice-item--1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-text--1" }, "余额不足提醒", -1))
const _hoisted_9 = { class: "notice-text--2" }
const _hoisted_10 = { class: "notice-item--3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_FormDialog = _resolveComponent("FormDialog")!

  return (_openBlock(), _createBlock(_component_FormDialog, {
    title: "余额提醒设置",
    width: "800px",
    formData: _ctx.editFormData,
    rules: _ctx.rules,
    showErrorToast: false,
    validateOnRuleChange: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleRef) = $event)),
    saveForm: _ctx.saveFormHandle
  }, {
    default: _withCtx(() => [
      (!_ctx.editFormData.items.length)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "暂无数据",
            image: "https://fscdn.zto.com/fs21/M02/A5/8F/CgRRhWFP2HOAQ-BpAACmZakqPMo943.png",
            "image-size": 200
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editFormData.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "notice-item flex",
          key: index
        }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              placement: "top"
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.customerName), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.customerName), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              placement: "top"
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.partnerId) + "-" + _toDisplayString(item.siteName), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.partnerId) + "-" + _toDisplayString(item.siteName), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", _hoisted_6, "余额：" + _toDisplayString(item.partnerBalance), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_switch, {
                modelValue: item.earlyWarningReminder,
                "onUpdate:modelValue": ($event: any) => ((item.earlyWarningReminder) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!item.earlyWarningReminder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "不提醒"))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_el_form_item, {
                    "label-width": "68px",
                    label: "余额 <",
                    style: {"margin-bottom":"0"},
                    prop: 'items.' + index + '.earlyWarningReminderValue',
                    rules: _ctx.rules.earlyWarningReminderValue
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "input-num",
                        placeholder: "请输入预警余额",
                        modelValue: item.earlyWarningReminderValue,
                        "onUpdate:modelValue": ($event: any) => ((item.earlyWarningReminderValue) = $event),
                        precision: 0,
                        controls: false,
                        max: 10000000000
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ]))
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["formData", "rules", "visible", "saveForm"]))
}